var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.publicToken)?_c('line-sheet-gate',{key:_vm.publicToken,attrs:{"public-token":_vm.publicToken,"query":_vm.$route.query}},[(!_vm.loading)?_c('wishlist-products',{attrs:{"public-token":_vm.publicToken}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }